import { getClientAlias } from 'util/client-alias';
import { incApi } from '../inc-api';
import { RefreshTokenArgs, Token, TokenArgs } from './oauth.types';

const endpoints = incApi.injectEndpoints({
  overrideExisting: true,
  endpoints: build => ({
    token: build.mutation<Token, TokenArgs>({
      query: ({ username, password }) => ({
        url: 'oauth/token',
        method: 'POST',
        headers: {
          authorization: 'Basic Y2xpZW50YXBwOjEyMzQ1Ng==',
          'content-type': 'application/x-www-form-urlencoded',
        },
        body: Object.entries({
          username,
          password,
          grant_type: 'password',
          scope: 'read write',
          client_alias: getClientAlias(),
        })
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
          )
          .join('&'),
      }),
    }),
    logout: build.query<void, void>({
      query: () => 'oauth/logout',
      keepUnusedDataFor: 0,
    }),
    refreshTokenByURL: build.mutation<Token, RefreshTokenArgs>({
      query: payload => ({
        url: 'oauth/token',
        method: 'POST',
        headers: {
          authorization: 'Basic Y2xpZW50YXBwOjEyMzQ1Ng==',
          'content-type': 'application/x-www-form-urlencoded',
        },
        body: Object.entries(payload)
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
          )
          .join('&'),
      }),
    }),
  }),
});

export const {
  useTokenMutation,
  useLazyLogoutQuery,
  useRefreshTokenByURLMutation,
} = endpoints;
